import { IRootState } from "app/model"
import { ICampaignList } from "campaign/model"
import React from "react"
import { connect } from "react-redux"
import { List } from "./List"

interface ICampaignListProps {
  list: ICampaignList
}

const CampaignListFn = ({ list }: ICampaignListProps): JSX.Element => <List list={list} />

export const CampaignList = connect(
  (state: IRootState): ICampaignListProps => ({
    list: state.campaign.campaignList
  })
)(CampaignListFn)
